import { mapActions, mapGetters } from 'vuex';
import { isIos } from 'util/fixes/ios-detect';


const SCROLL_LOCK_IOS_FIX_CLASS = 'u-scroll-lock-ios-fix';


export default {
    data() {
        return {
            scrollLockHelperStyleProp: 'paddingRight',
        };
    },
    computed: {
        ...mapGetters(['scroll']),
        scrollLockStyles() {
            return {
                [this.scrollLockHelperStyleProp]: (this.scroll.isLocked ? `${ this.scroll.scrollbarWidth }px` : ''),
            };
        },
        scrollLockIosFixClasses() {
            return [SCROLL_LOCK_IOS_FIX_CLASS];
        },
    },
    methods: {
        ...mapActions(['lockScroll']),
        onScrollLockEnterHook() {
            this.lockScroll({ isLocked: true });
        },
        onScrollLockAfterLeaveHook() {
            this.lockScroll({ isLocked: false });
        },
        scrollLockIosFixForceUpdate($element) {
            // NOTE: The property that is being updated must change the position somehow to force an update
            const top = parseFloat(window.getComputedStyle($element).marginTop) || 0;
            $element.style.marginTop = `${ top - 0.5 }px`;

            setTimeout(() => {
                this.$nextTick(() => {
                    $element.style.marginTop = null;
                });
            }, 0);
        },
    },
    watch: {
        'scroll.isLocked': {
            handler() {
                // NOTE: After a scroll-lock, fixed elements must be forced to the right position on iOS
                if (!isIos) {
                    return;
                }

                Array.from(this.$el.querySelectorAll(`.${ SCROLL_LOCK_IOS_FIX_CLASS }`))
                    .forEach(this.scrollLockIosFixForceUpdate);
            },
        },
    },
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/mixins/scroll-lock-helper/index.js